
<template>
  <transition name="fade">
    <div class="ui-confirm ui-confirm-v2" :class="{ ios: isIOS, show: show }" v-show="show">
      <div class="ui-confirm-dialog">
        <img
          class="dialog-close"
          @click="handleClose($event, 'closeBtn')"
          src="../../../assets/contribute/close-icon.png"
        />
        <div class="dialog-content">
          <div class="dialog-title" v-if="title">{{ title }}</div>
          <div class="dialog-desc">{{ content }}</div>
        </div>
        <div class="dialog-btns">
          <div
            class="dialog-btns-cancel"
            v-if="cancelText"
            @click="handleClose($event, 'cancelBtn')"
          >
            {{ cancelText }}
          </div>
          <div
            class="dialog-btns-confirm"
            v-if="confirmText"
            @click="handleConfirm"
          >
            {{ confirmText }}
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { isIOS } from "../../../utils/ua";

export default {
  name: "confirmV2",
  data() {
    return {
      isIOS: isIOS(),
      show: false,
      title: "",
      content: "",
      cancelText: "取消",
      confirmText: "确认",
      onClose: () => {},
      onConfirm: () => {},
    };
  },
  methods: {
    handleClose(event, position) {
      event.stopPropagation();
      this.show = false;
      typeof this.onClose === "function" && this.onClose(position);
    },
    handleConfirm(event) {
      event.stopPropagation();
      this.show = false;
      typeof this.onConfirm === "function" && this.onConfirm();
    },
  },
  watch: {
    /**
     * @desc 弹框时禁止滚动
     */
    show(value) {
      if (value) {
        // show
        document.body.style.overflow = "hidden";
      } else {
        // hidden
        document.body.style.overflow = "initial";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/px2rem.scss";
// 设计稿宽度
$designWidth: 375;

.ui-confirm {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1000;
  user-select: none;
  &.ios {
    .ui-confirm-dialog {
      transform: translate(-50%, -80%) scale(1);
    }
  }
  .ui-confirm-dialog {
    position: absolute;
    top: 50%;
    left: 50%;
    padding: px2rem(30);
    width: px2rem(320);
    min-height: px2rem(184);
    border-radius: px2rem(5);
    background-color: #fff;
    transform: translate(-50%, -50%);
    transition: transform 0.3s ease-in-out;
  }
  .dialog-close {
    position: absolute;
    top: px2rem(10);
    right: px2rem(10);
    width: px2rem(12);
    height: px2rem(12);
    padding: px2rem(5);
    box-sizing: content-box;
  }
  .dialog-content {
    padding: px2rem(5) 0 px2rem(5);
    min-height: px2rem(100);
    font-size: px2rem(14);
    line-height: px2rem(20);
    color: #222222;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    .dialog-title {
      font-size: px2rem(16);
      font-weight: bold;
      text-align: center;
      color: #222222;
    }
    .dialog-desc {
      margin: px2rem(5) 0;
      text-align: center;
    }
  }
  .dialog-btns {
    display: flex;
    .dialog-btns-cancel,
    .dialog-btns-confirm {
      height: px2rem(36);
      border-radius: px2rem(18);
      flex: 1;
      background-color: #e7e7e7;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: px2rem(14);
      color: #222222;
      user-select: none;
    }
    .dialog-btns-cancel {
      margin-right: px2rem(12);
    }
    .dialog-btns-confirm {
      color: #fff;
      background-image: linear-gradient(
        to right,
        rgb(253, 44, 124),
        rgb(245, 129, 101)
      );
    }
  }
}
</style>
